<template>
  <div class="flex items-center justify-between gap-4 font-semibold">
    <button @click="$emit('previous')">
      <div class="scale-75 transform">
        <i v-html="$icons.arrow_left" />
      </div>
    </button>
    <div class="flex w-full items-center gap-4">
      <button
        @click="$emit('toggle-month-selector')"
        class="flex w-full items-center justify-center"
      >
        {{ capitalize(moment(displayedDate).format("MMMM")) }}
      </button>
      <button
        @click="$emit('toggle-year-selector')"
        class="flex w-full items-center justify-center"
      >
        {{ capitalize(moment(displayedDate).format("YYYY")) }}
      </button>
    </div>
    <button @click="$emit('next')">
      <div class="rotate-180 scale-75 transform">
        <i v-html="$icons.arrow_left" />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    displayedDate: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  @apply font-semibold filter transition-all hover:brightness-125;
}
</style>
